import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GetcCuntryCodesReferential } from '@/features/borderCrossingRORO/onBoarding/subscribePublicForm/types';
import { REFERENCIALS_URL, useGetReferentialsAsync } from '@/features/shared/apis';

export const useCountriesReferentialOptions = () => {
  const { t } = useTranslation('countries');

  const { data: countriesCodeData, isLoading: isGetCountriesCodeLoading } =
    useGetReferentialsAsync<GetcCuntryCodesReferential>(REFERENCIALS_URL.COUNTRY_CODE, { isAnonymous: true });

  const countriesOptions = useMemo(
    () =>
      (countriesCodeData?.countryCodes ?? []).map(({ id, translationKey }) => ({
        label: t(translationKey),
        value: id,
      })),
    [countriesCodeData?.countryCodes, t],
  );

  return {
    isGetCountriesCodeLoading,
    countriesOptions,
  };
};
